const apiUrl = process.env.REACT_APP_API_URL;
export const GetJutgeProblemes = async (id: string) => {
    try {
        const response = await fetch(`${apiUrl}:8061/jutge/problemes`,
            {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify({ id })
            });
        const jsonData = await response.json();
        return jsonData;
    } catch (error) {
        console.log('Error al obtener los datos:', error);
    }
};
